import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AlertCircle, Fingerprint, LogOut } from "lucide-react";

import { formatPhone } from "../../Utils/ValidationsMasks";
import { deleteAllLocalStorage } from "../../Utils/local-storage";
import { useBiometricValidation } from "../../Contexts/biometric-validation";
import { Layout } from "../../Components/layout";
import { Alert, Button, Col, Form, Row, Spinner } from "react-bootstrap";

import "./styles.css";

export function BiometriaLogin() {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(null);

  const { hash } = useParams();
  const navigate = useNavigate();
  const { signInLoading, onSign } = useBiometricValidation();

  async function handleSignIn() {
    const cleanPhone = phone?.replace(/\D/g, "");

    if (!cleanPhone) {
      setError("Por favor, digite o número do seu celular.");
      return;
    }

    if (cleanPhone?.length < 11) {
      setError("O número do celular deve conter o DDD e 9 dígitos.");
      return;
    }

    deleteAllLocalStorage();

    if (hash) {
      let result;

      try {
        result = await onSign({
          phone: phone?.replace(/\D/g, ""),
          token: hash,
        });
      } catch (error) {
        setError(error?.message);
      }

      if (result && [200, 201, 204].includes(result.status)) {
        navigate("/biometria/info");
      }
    }
  }

  if (error) {
    return (
      <Layout cardStyle={{ minHeight: "50vh" }}>
        <Row className="row_container">
          <Alert
            variant="danger"
            className="rounded mx-auto mb-5 border border-danger"
            style={{ width: "fit-content" }}
          >
            <AlertCircle
              style={{ height: "40px", width: "40px" }}
              className="text-danger"
            />
          </Alert>

          <h1 className="title text-center mb-3">Atenção</h1>

          <p className="text-muted mb-5 text-center">{error}</p>

          <Button onClick={() => setError(null)} style={{ fontSize: "1.5rem" }}>
            Tentar Novamente
          </Button>
        </Row>
      </Layout>
    );
  }

  return (
    <Layout>
      <Row className="row_container">
        <Col className="text-center mb-4">
          <Alert className="icon_container p-2 mb-4">
            <Fingerprint className="icon_style" />
          </Alert>
          <h1 className="title">Validação da Biometria</h1>
          <p className="subtitle">
            Seja bem-vindo ao Flex GR, caro motorista. Informe o seu celular.
          </p>
        </Col>

        <Col className="input_container mb-3">
          <Form.Control
            type="tel"
            placeholder="(00) 00000-0000"
            size="lg"
            value={phone}
            onChange={(e) => setPhone(formatPhone(e.target.value))}
            className={`input_style ${phone.length > 0 && phone.replace(/\D/g, "").length < 11 ? "border-danger" : ""}`}
          />

          {phone?.length > 0 && phone?.replace(/\D/g, "")?.length < 11 && (
            <span className="small text-danger ms-1">
              Digite um número válido com DDD
            </span>
          )}
        </Col>

        <Col className="d-flex flex-column gap-3">
          <Button
            onClick={handleSignIn}
            disabled={phone?.replace(/\D/g, "")?.length < 11 || signInLoading}
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
          >
            {signInLoading ? (
              <Spinner role="status" animation="border" size="sm" />
            ) : null}
            {signInLoading ? "Aguarde..." : "Continuar"}
          </Button>
          <Button
            disabled={signInLoading}
            onClick={() => navigate("/biometria/cancelar")}
            variant="danger"
            className="py-2 d-flex align-items-center justify-content-center gap-2"
            size="lg"
          >
            <LogOut />
            Sair da validação
          </Button>
        </Col>
      </Row>
    </Layout>
  );
}
